import { createFileRoute } from '@tanstack/react-router';

import { McpConnectionsPage } from '@apps/web/features/admin_v3_playground/mcp_connections/page';

export const Route = createFileRoute('/_app/admin/agent/connections')({
    head: () => ({ meta: [{ title: 'Connections | Internal Admin Agent' }] }),
    component: McpConnectionsPage,
});
